import { render, staticRenderFns } from "./LeaveEditForm.vue?vue&type=template&id=20097c95&"
import script from "./LeaveEditForm.vue?vue&type=script&lang=js&"
export * from "./LeaveEditForm.vue?vue&type=script&lang=js&"
import style0 from "./LeaveEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports